var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretRoundUp = function SvgCaretRoundUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.853553 3.8131C0.53857 4.12809 0.761654 4.66666 1.20711 4.66666H6.79289C7.23835 4.66666 7.46143 4.12809 7.14645 3.8131L4.35355 1.02021C4.15829 0.824947 3.84171 0.824948 3.64645 1.02021L0.853553 3.8131Z",
    fill: "currentColor"
  })));
};
export default SvgCaretRoundUp;